module.exports = __webpack_public_path__ + "aaf0c3c2dc8575e95c7a9cc9e25836b8.pdf";